import { render, staticRenderFns } from "./reset_tel.vue?vue&type=template&id=78ea4104&scoped=true&"
import script from "./reset_tel.vue?vue&type=script&lang=js&"
export * from "./reset_tel.vue?vue&type=script&lang=js&"
import style0 from "./reset_tel.vue?vue&type=style&index=0&id=78ea4104&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ea4104",
  null
  
)

export default component.exports